import { memo } from 'react'
import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { EventTaskTable } from './components/eventTaskTable/eventTaskTable'
import { EventDetailTaskListToolbar } from './components/eventDetailTaskListToolbar/eventDetailTaskListToolbar'

export const EventDetailTaskList = memo(() => {
  return (
    <>
      <CrewErrorBoundary>
        <EventDetailTaskListToolbar />
      </CrewErrorBoundary>
      <CrewErrorBoundary>
        <div className="px-2 overflow-y-auto">
          <EventTaskTable />
        </div>
      </CrewErrorBoundary>
    </>
  )
})
